import { Grid, Skeleton, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import Link from 'next/link';
import { getAllBlogPosts } from 'src/logic/services/blog';
import { sm } from 'src/site-map';
import BlogPostCard from '../blog/BlogPostCard';
import PrimaryButton from '../components/buttons/PrimaryButton';

const MAX_POSTS = 3;

const HomeBlogPosts = () => {
  const { data } = useQuery({
    queryKey: ['LANDING_PAGE_BLOG_POSTS'],
    queryFn: async () => {
      const { data } = await getAllBlogPosts(1, MAX_POSTS);
      return data.data;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 1,
  });
  const posts = data?.data;
  const hasMore = !!data?.meta?.total && data.meta.total > MAX_POSTS;

  return (
    <div className='page__content' style={{ paddingBlock: '4rem' }}>
      <Typography
        textAlign={'center'}
        px={1}
        fontSize={{ xs: 26, lg: 44 }}
        fontWeight={600}
        color='#070A0D'
        mx='auto'
        lineHeight={1}
        component='h3'
        maxWidth={'17ch'}
      >
        Stay Updated With <span style={{ color: '#005FCC' }}>Our Latest Posts</span>
      </Typography>

      <div>
        <Grid container spacing={2} py={2}>
          {posts ? (
            <>
              {posts.map(post => (
                <Grid key={post.id} item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <BlogPostCard post={post} />
                </Grid>
              ))}
            </>
          ) : (
            <>
              {[1, 2, 3].map(num => (
                <Grid key={num} item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <Skeleton variant='rectangular' width='100%' height={300} sx={{ borderRadius: '20px', mr: 4 }} />
                </Grid>
              ))}
            </>
          )}
        </Grid>
      </div>

      {hasMore && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '1rem' }}>
          <Link href={sm.blog.index.url} passHref>
            <PrimaryButton sx={{ px: 8 }}>More Posts</PrimaryButton>
          </Link>
        </div>
      )}
    </div>
  );
};

export default HomeBlogPosts;
